<app-breadcrumbs [title]="'MENU.ADMINISTRATION.DISTRIBUTION_CALENDARS'" [first]="'MENU.ADMINISTRATION.DISTRIBUTION_CALENDARS'"></app-breadcrumbs>

<div class="btn-container">
    <dx-button *ngIf="authorities.create" class="ml-2 navbar-button" [height]="32" stylingMode="contained" icon="event" [text]="'DISTRIBUTION_CALENDARS.GENERATE' | translate" type="success" (onClick)="openGenerateDistributionCalendarsModal()"></dx-button>
</div>

<div class="container">
    <div class="row">
        <div class="col-12">
            <dx-scheduler class="distribution-calendar" [dataSource]="distributionCalendars" [views]="views" [currentView]="currentView" cellDuration="30" [adaptivityEnabled]="adaptivityEnabled" [startDayHour]="8" [endDayHour]="23" [currentDate]="currentDate" height="85vh" timeCellTemplate="timeCellTemplate"
                appointmentTooltipTemplate="appointmentTooltipTemplate" appointmentTemplate="calendarTemplate" (onOptionChanged)="onOptionChanged($event)" (onAppointmentAdded)="onAppointmentAdded($event)" (onAppointmentUpdated)="onAppointmentUpdated($event)"
                (onAppointmentDeleted)="onAppointmentDeleted($event)" (onAppointmentFormOpening)="onAppointmentFormOpening($event)" >
            <dxo-editing #editingOptions [allowAdding]="authorities.create" [allowDeleting]="authorities.delete" [allowUpdating]="authorities.update" [allowResizing]="false" [allowDragging]="false"></dxo-editing>

                <div *dxTemplate="let data of 'timeCellTemplate'">
                    {{ utilityService.formatTimeFromDate(data.date) }}
                </div>

                <div *dxTemplate="let model of 'appointmentTooltipTemplate'">
                    <div class="row">
                        <div class="col-2">
                            <i *ngIf="model.appointmentData.active" class="dot bg-icon-green" [matTooltip]="'SHARED.DEACTIVATE' | translate" matTooltipPosition="above" matTooltipHideDelay="200" (click)="activate(model.appointmentData)"></i>
                            <i *ngIf="!model.appointmentData.active" class="dot bg-icon-red" [matTooltip]="'SHARED.ACTIVATE' | translate" matTooltipPosition="above" matTooltipHideDelay="200" (click)="activate(model.appointmentData)"></i>
                        </div>
                        <div class="col-8">
                            <!-- POS visible if there is more than 1 POS -->
                            <div *ngIf="showPOSname" class="pos-name">{{ model.appointmentData.pointOfSale?.name }}</div>
                            <div>{{ model.appointmentData.pointOfSale?.name }}, {{ model.appointmentData.deliveryZone?.name }}</div>
                            <div>
                                {{utilityService.formatTime(model.appointmentData.timeFrom) + ' - ' + utilityService.formatTime(model.appointmentData.timeTo)}}
                            </div>
                            <div class="capacity">{{ 'DISTRIBUTION_CALENDARS.CAPACITY' | translate }}:
                                <strong>{{ model.appointmentData.capacity }}</strong>
                            </div>
                            <div class="used-capacity">{{ 'DISTRIBUTION_CALENDARS.USED_CAPACITY_SHORT' | translate }}:
                                <strong>{{ model.appointmentData.usedCapacity ? model.appointmentData.usedCapacity : 0 }}</strong>
                            </div>
                        </div>
                        <div class="col-2" (click)="delete(model.appointmentData)">
                            <i class="table-icon dx-icon-trash text-xx-large" [matTooltip]="'SHARED.DELETE' | translate" matTooltipPosition="above" matTooltipHideDelay="200"></i>
                        </div>
                    </div>
                </div>

                <div *dxTemplate="let data of 'dateCellTemplate'">
                    <div class="name text-center">{{[ ('ENUMS.DAYS_OF_WEEK_SHORT.SUNDAY' | translate), ('ENUMS.DAYS_OF_WEEK_SHORT.MONDAY' | translate), ('ENUMS.DAYS_OF_WEEK_SHORT.TUESDAY' | translate), ('ENUMS.DAYS_OF_WEEK_SHORT.WEDNESDAY' | translate), ('ENUMS.DAYS_OF_WEEK_SHORT.THURSDAY'
                        | translate), ('ENUMS.DAYS_OF_WEEK_SHORT.FRIDAY' | translate), ('ENUMS.DAYS_OF_WEEK_SHORT.SATURDAY' | translate)][data.date.getDay()]}}</div>
                    <div class="number text-center">{{data.date.getDate()}}</div>
                </div>

                <div *dxTemplate="let model of 'calendarTemplate'">
                    <div [ngClass]="setBackgroundColor(model.appointmentData.capacity, model.appointmentData.usedCapacity)" class="calendar-preview type-{{currentView}} type-{{currentView?.type}}">
                        <!-- POS visible if there is more than 1 POS -->
                        <div *ngIf="showPOSname" class="pos-name">{{ model.appointmentData.pointOfSale?.name }}</div>
                        <div class="deliveryZone-name">{{ model.appointmentData.deliveryZone?.name }}</div>
                        <div class='dropdown-appointment-dates'>
                            {{utilityService.formatTime(model.appointmentData.timeFrom) + ' - ' + utilityService.formatTime(model.appointmentData.timeTo)}}
                        </div>
                        <div class="capacity">{{ 'DISTRIBUTION_CALENDARS.CAPACITY' | translate }}:
                            <strong>{{ model.appointmentData.capacity }}</strong>
                        </div>
                        <div class="used-capacity">{{ 'DISTRIBUTION_CALENDARS.USED_CAPACITY_SHORT' | translate }}:
                            <strong>{{ model.appointmentData.usedCapacity ? model.appointmentData.usedCapacity : 0 }}</strong>
                        </div>
                    </div>
                </div>
            </dx-scheduler>
        </div>
    </div>
</div>

<dx-popup width="600px" maxWidth="80%" height="490px" maxHeight="90%" [(visible)]="isGenerateDistributionCalendarsModalVisible" showCloseButton="true" [title]="'DISTRIBUTION_CALENDARS.GENERATE' | translate" (onHiding)="closeGenerateDistributionCalendarsModal()">

    <div class="col-12">
        <div class="dx-fieldset">
            <div class="dx-field">
                <div class="dx-field-label">{{ 'POINTS_OF_SALE.POINT_OF_SALE' | translate}}</div>
                <div class="dx-field-value">
                    <dx-select-box [(value)]="formPointOfSale" [dataSource]="pointsOfSale" valueExpr="id" displayExpr="name" [showClearButton]="true">
                    </dx-select-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label">{{ 'MEANS_OF_DELIVERY.MEAN_OF_DELIVERY' | translate}}</div>
                <div class="dx-field-value">
                    <dx-select-box [(value)]="formMeansOfDelivery" [dataSource]="meansOfDelivery" valueExpr="id" displayExpr="description" [showClearButton]="true"></dx-select-box>
                </div>
            </div>
            <!-- <div class="dx-field">
                <div class="dx-field-label">{{ 'SHARED.DELIVERY_ZONE' | translate}}</div>
                <div class="dx-field-value">
                    <dx-select-box [(value)]="formDeliveryZone" [dataSource]="deliveryZones" valueExpr="id" displayExpr="name" [showClearButton]="true">
                    </dx-select-box>
                </div>
            </div> -->
            <div class="dx-field">
                <div class="dx-field-label">{{ 'SHARED.DELIVERY_ZONE' | translate}}</div>
                <div class="dx-field-value">
                    <dx-tag-box [dataSource]="deliveryZones" valueExpr="id" displayExpr="name" [searchEnabled]="true" [(value)]="selectedDeliveryZones" [showSelectionControls]="true" [multiline]="false" applyValueMode="useButtons"></dx-tag-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label">{{ 'SHARED.DATE_FROM' | translate }}</div>
                <div class="dx-field-value">
                    <dx-date-box [(value)]="formDateFrom" displayFormat="dd.MM.yyyy" pickerType="calendar" [min]="minDate" dateSerializationFormat="yyyy-MM-ddTHH:mm:ss"></dx-date-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label">{{ 'SHARED.DATE_TO' | translate }}</div>
                <div class="dx-field-value">
                    <dx-date-box [(value)]="formDateTo" displayFormat="dd.MM.yyyy" pickerType="calendar" [min]="minDate" dateSerializationFormat="yyyy-MM-ddTHH:mm:ss"></dx-date-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label">{{ 'DISTRIBUTION_CALENDARS.CHECK_CAPACITIES_AS_USED' | translate}} </div>
                <div class="dx-field-value d-flex">
                    <dx-check-box [(value)]="useCapacitiesUp"></dx-check-box>
                </div>
            </div>
        </div>
    </div>

    <hr>
    <div class="dx-popup-footer">
        <div class="row col-sm-8 offset-sm-2">
            <div class="col-sm">
                <dx-button class="navbar-button btn-block" [height]="32" stylingMode="contained" icon="event" [text]="'DISTRIBUTION_CALENDARS.GENERATE_SHORT' | translate" type="success" (onClick)="generateDistributionCalendars()"></dx-button>
            </div>
            <div class="col-sm">
                <dx-button class="navbar-button btn-block" [height]="32" stylingMode="outlined" icon="close" [text]="'SHARED.CLOSE' | translate" type="normal" (onClick)="closeGenerateDistributionCalendarsModal()"></dx-button>
            </div>
        </div>
    </div>
</dx-popup>